
import { Tooltip } from 'bootstrap';

import {
  defineComponent,
  onMounted,
  ref,
} from 'vue';

export default defineComponent({
  props: {
    trigger: {
      type: String,
      required: false,
      default: () => 'hover focus',
    },
  },

  setup() {
    const root = ref<InstanceType<typeof HTMLElement>>();
    const tooltip = ref<Tooltip | null>(null);

    onMounted(() => {
      const title = root.value?.querySelector('[data-ref="title"]');

      if (root.value && title) {
        tooltip.value = new Tooltip(root.value, {
          html: true,
          title: title.innerHTML,
        });

        title.remove();
      }
    });

    return {
      root,
    };
  },
});
